var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:[_vm.typeButton, _vm.$vuetify.breakpoint.smAndDown && 'mobile'],attrs:{"text":"","disabled":_vm.disable},on:{"click":_vm.handleClickEvaluationBtn}},[_c('img',{staticClass:"mr-2",attrs:{"src":_vm.getIcon(_vm.prependIcon)}}),_c('h6',{class:{
      easyTypeColor: _vm.typeButton === 'easyType',
      normalTypeColor: _vm.typeButton === 'normalType',
      hardTypeColor: _vm.typeButton === 'hardType',
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }